import { API_ROUTES } from '@/constants';
import { IsAiresEmptyResponse, OSType, UploadFunctionResponse } from '@/types';

import { apiServices } from './services';

const { dataManagementApiService } = apiServices;

export const getDataPrepareDownloadStatus = (osType?: OSType) =>
  dataManagementApiService.get(`${API_ROUTES.DATA_PREPARER_INFO}${osType}`);

export const getDataPrepareInfo = () => dataManagementApiService.get(API_ROUTES.DATA_PREPARER_VERSION);
export const getIsAreaEmpty = (): Promise<IsAiresEmptyResponse> =>
  dataManagementApiService.get(API_ROUTES.AIRES_FILES_IS_EMPTY);
export const getSubmissionData = () => dataManagementApiService.get(API_ROUTES.GET_SUBMISSIONS);
export const uploadFilesData = (data: FormData): Promise<UploadFunctionResponse> =>
  dataManagementApiService.post(API_ROUTES.UPLOAD_FILES, data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
export const getCuInfo = async () => dataManagementApiService.get(API_ROUTES.INFO);
